import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getUrlParam } from '../../Helpers/helpers';
import { getReferringUser as getReferringUserAPI } from '../../APIClient/users';
import { fetchReferringBrand as fetchReferringBrandAPI } from '../../APIClient/brands';
import { addEvent } from '../../APIClient/events';

const CreatorApplicationData = props => {
  const creatorApplication = props.application.creatorApplication;
  const referringUsername = getUrlParam('referral') || creatorApplication.referringUser?.username;
  const referringBrand_id = getUrlParam('referring_brand') || creatorApplication.referringBrand?.id;

  useEffect(() => {
    addEvent(`Creator Application - Creator Application Page View`, { referringUsername: referringUsername, referringBrand_id });

    const loadCreator = async () => {
      try {
        const resp = await getReferringUserAPI(referringUsername);
        props.setReferringUser(resp.user);
      } catch (error) {
        console.error(error);
        window.ALERT.error("We couldn't find a user with that referral link. Please double check your link and try again.");
      }
    };

    const loadBrand = async () => {
      try {
        const resp = await fetchReferringBrandAPI(referringBrand_id);
        props.setReferringBrand(resp.brand);
      } catch (error) {
        console.error(error);
        window.ALERT.error("We couldn't find a brand with that referral link. Please double check your link and try again.");
      }
    };

    if (referringUsername) loadCreator();
    else if (referringBrand_id) loadBrand();
  }, [referringUsername]);

  return null;
};

CreatorApplicationData.propTypes = {
  application: PropTypes.object.isRequired,
  setReferringUser: PropTypes.func.isRequired,
  setReferringBrand: PropTypes.func.isRequired
};

export default CreatorApplicationData;
